// Invoice types based on backend models
export type InvoiceStatus = "DRAFT" | "SUBMITTED" | "APPROVED" | "REJECTED";

export interface Invoice {
  id: number;
  contractorContractId?: string; // UUID of the associated contract
  invoiceNumber?: string;
  dueDate: string;
  status: InvoiceStatus;
  notes?: string;
  lineItems: InvoiceLineItem[];
  subtotal: number;
  totalTax: number;
  grandTotal: number;
  createdAt: string;
  updatedAt: string;
}

export interface InvoiceLineItem {
  id: number;
  product: string;
  description?: string;
  rate: number;
  quantity: number;
  tax: number;
  total: number;
  lineOrder: number;
}

export interface AvailableContract {
  id: string; // UUID
  contractTitle: string;
  clientId?: number;
  startDate?: string;
  endDate?: string;
  schedule_a_services_description?: string;
  fee_rate?: number;
}

export interface GetAvailableContractsResponse {
  contracts: AvailableContract[];
}

export interface CreateInvoiceRequest {
  contractorContractId: string; // UUID of the contract
  dueDate: string;
  invoiceNumber?: string;
  notes?: string;
  lineItems: CreateInvoiceLineItemRequest[];
}

export interface CreateInvoiceLineItemRequest {
  product: string;
  description?: string;
  rate: number;
  quantity: number;
  tax: number;
}

export interface GetInvoicesResponse {
  invoices: Invoice[];
}

export interface CreateInvoiceResponse {
  invoice: Invoice;
}

export interface UpdateInvoiceRequest {
  contractorContractId: string; // UUID of the contract
  dueDate: string;
  invoiceNumber?: string;
  notes?: string;
  lineItems: CreateInvoiceLineItemRequest[];
}

export interface UpdateInvoiceResponse {
  invoice: Invoice;
}

export interface UpdateInvoiceStatusRequest {
  status: InvoiceStatus;
}

// Utility types
export const InvoiceStatusLabels: Record<InvoiceStatus, string> = {
  DRAFT: "Draft",
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

export const InvoiceStatusColors: Record<InvoiceStatus, string> = {
  DRAFT: "bg-gray-100 text-gray-800",
  SUBMITTED: "bg-blue-100 text-blue-800",
  APPROVED: "bg-green-100 text-green-800",
  REJECTED: "bg-red-100 text-red-800",
}; 